

$(".navbar-toggler").click(function(){

  $(".navbar-toggler").toggleClass("showtoggle");
  $('body').toggleClass("showbody");

});



$(".closed").click(function(){

  $(".navbar-collapse").removeClass("show");

});   


    $(".jobsbtn a").click(function(){
        $(".topjobbox").slideToggle("slow");
    });


    $(".searh_bx a").click(function(){
        $(".topjobbox").slideToggle("slow");
    });


$(window).scroll(function() {    
    var scroll = $(window).scrollTop();
    if (scroll >= 50) {
        $(".header_sec").addClass("fixed");

    } else {
        $(".header_sec").removeClass("fixed");
    }
    
});
$('.hero-slider').owlCarousel({
    items: 1,
    loop: true,
    autoplay: true,
    autoplayTimeout: 4000,
    autoplayHoverPause: false,

    animateIn: 'fadeIn',
    animateOut: 'fadeOut',

    smartSpeed: 1500,

    nav: false,
    dots: false,

    mouseDrag: false,
    touchDrag: false
});

$(document).ready(function () {

    $('.industry-carousel').owlCarousel({
        loop: true,
        margin:0,
        nav: true,
        dots: false,
        autoplay: false,
        smartSpeed: 500,

        navText: [
            '<i class="fa-solid fa-chevron-left"></i>',
            '<i class="fa-solid fa-chevron-right"></i>'
        ],

        responsive: {
            0: {
                items: 1
            },
            440: {
                items: 2
            },
            576: {
                items: 3
            },
            768: {
                items: 4
            },
            992: {
                items: 5
            }
        }
    });

});

$(document).ready(function () {

    $('.featured-roles-carousel').owlCarousel({

        loop: true,

        margin: 20,

        nav: false,

        dots: false,

        autoplay: true,

        autoplayTimeout: 4000,

        autoplayHoverPause: true,

        smartSpeed: 700,

        navText: [
            '<i class="fa-solid fa-chevron-left"></i>',
            '<i class="fa-solid fa-chevron-right"></i>'
        ],

        responsive: {

            0: {
                items: 1
            },

            576: {
                items: 2
            },

            992: {
                items: 3
            }

        }

    });

});

$(document).ready(function () {

    $('.news-carousel').owlCarousel({

        loop: true,

        margin: 20,

        nav: false,

        dots: false,

        autoplay: false,

        smartSpeed: 600,

        navText: [
            '<i class="fa-solid fa-chevron-left"></i>',
            '<i class="fa-solid fa-chevron-right"></i>'
        ],

        responsive: {

            0: {
                items: 1
            },

            576: {
                items: 2
            },

            992: {
                items: 3
            }

        }

    });

});

$(document).ready(function () {

    $('.client-logo-carousel').owlCarousel({

        loop: true,

        margin: 20,

        nav: false,

        dots: false,

        autoplay: true,

        autoplayTimeout: 2500,

        autoplayHoverPause: true,

        smartSpeed: 800,

        responsive: {

            0: {
                items: 2
            },

            576: {
                items: 3
            },

            768: {
                items: 4
            },

            992: {
                items: 5
            },

            1200: {
                items: 6
            }

        }

    });

});


$(document).ready(function () {

    $('.valus-carousel').owlCarousel({

        loop: true,

        margin: 20,

        nav: false,

        dots: false,

        autoplay: false,

        smartSpeed: 600,

        navText: [
            '<i class="fa-solid fa-chevron-left"></i>',
            '<i class="fa-solid fa-chevron-right"></i>'
        ],

        responsive: {

            0: {
                items: 1
            },

            576: {
                items: 2
            },

            992: {
                items: 3
            },
            1200: {
                items: 4
            }

        }

    });

});


document.addEventListener("DOMContentLoaded", function () {

    const counters = document.querySelectorAll(".counter");

    function animateCounter(counter) {
        if (counter.dataset.started === "true") return;

        counter.dataset.started = "true";

        const target = Number(counter.getAttribute("data-count"));

        if (!Number.isFinite(target)) return;

        const duration = 2000;
        const startTime = performance.now();

        function update(now) {
            const progress = Math.min((now - startTime) / duration, 1);
            const eased = 1 - Math.pow(1 - progress, 3);

            counter.textContent = Math.round(target * eased).toLocaleString("en-US");

            if (progress < 1) {
                requestAnimationFrame(update);
            } else {
                counter.textContent = target.toLocaleString("en-US");
            }
        }

        requestAnimationFrame(update);
    }

    const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                animateCounter(entry.target);
                observer.unobserve(entry.target);
            }
        });
    }, { threshold: 0.1 });

    counters.forEach(function (counter) {
        observer.observe(counter);
    });

});
